export default __webpack_public_path__ + "static/media/spinner.a0b9c852.svg";